import React, { ReactElement } from 'react';
import MaskedTextInput from 'react-text-mask';

import ErrorInput from '../ErrorInput/errorInput';

import { MaskInputProps } from '../../types/maskedInput.types';

const MaskedInput: React.FC<MaskInputProps> = (props: MaskInputProps) => {
  const {
    value,
    mask,
    name,
    label,
    placeholder,
    errors,
    id,
    onChange,
    error,
    feedbackText,
    isLoading,
    guide,
    placeholderChar,
    keepCharPositions,
    showMask,
    pipe,
    onFocus,
  } = props;

  return (
    <MaskedTextInput
      mask={mask}
      value={value}
      guide={guide}
      placeholderChar={placeholderChar}
      keepCharPositions={keepCharPositions}
      showMask={showMask}
      pipe={pipe}
      onFocus={onFocus}
      onChange={(
        e: React.ChangeEvent<HTMLInputElement>,
      ): React.ChangeEvent<HTMLInputElement> => onChange && onChange(e)}
      render={(ref, inputProps): ReactElement => (
        <ErrorInput
          {...inputProps}
          id={id}
          inputRef={(inputRef: HTMLInputElement): void => {
            ref(inputRef);
            const hasFocusEvent =
              inputRef && inputRef.getAttribute('focusListener');
            inputRef &&
              !hasFocusEvent &&
              inputRef.addEventListener('focus', () => onFocus && onFocus());
            inputRef && inputRef.setAttribute('focusListener', 'true');
          }}
          name={name}
          label={label}
          placeholder={placeholder}
          errors={errors}
          error={error}
          isLoading={isLoading}
          feedbackText={feedbackText}
        />
      )}
    />
  );
};

export default MaskedInput;
